import { useEffect } from "react";

const SITE = "https://convergedsecurity.courses";
const DEFAULT_DESC = "Converged Security Institute (CSI) - professional qualifications in converged security leadership: CSCE, CSP, CSL, CCSO and the PGDCSL Postgraduate Executive Diploma.";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export function useSeo({ title, description, path, noindex = false, jsonLd = null, image = null }) {
  useEffect(() => {
    if (!title) return;
    const full = title.includes("Converged Security Institute") ? title : `${title} | Converged Security Institute`;
    const desc = (description || DEFAULT_DESC).replace(/\s+/g, " ").slice(0, 160);
    const url = `${SITE}${path ?? window.location.pathname}`;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", desc);
    setMeta("property", "og:image", image || `${SITE}/og-image.jpg`);
    setMeta("name", "twitter:image", image || `${SITE}/og-image.jpg`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "page";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, noindex, image, jsonLd ? JSON.stringify(jsonLd) : null]); // eslint-disable-line react-hooks/exhaustive-deps
}
